import React, { useState } from "react";
import colis_service from "../../services/colis-service";

const Add_colis = () => {
  const [formData, setFormData] = useState({
    client_code: "",
    user_name: "",
    colis_number: "",
    weight: "",
    dimension: "",
    price: "",
    sending_option: "Aérien_Normal",
    status: "Expédié",
    departure_date: "",
    arrival_date: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: "", type: "" });

    try {
      const colisData = {
        client_code: formData.client_code,
        user_name: formData.user_name,
        colis_number: formData.colis_number,
        weight: formData.weight, 
        dimension: formData.dimension,
        price: formData.price, 
        sending_option: formData.sending_option,
        status: formData.status,
        departure_date: formData.departure_date,
        arrival_date: formData.arrival_date,
      };
      const response = await colis_service.create(colisData);
      setMessage({
        text: "Colis ajouté avec succès!",
        type: "success",
      });

      setFormData({
        client_code: "",
        user_name: "",
        colis_number: "",
        weight: "",
        dimension: "",
        price: "",
        sending_option:"Aérien_Normal",
        status:"Expédié",
        departure_date: "",
        arrival_date: "",
      });
    } catch (error) {
      setMessage({
        text: `Erreur: ${error.message || "Une erreur est survenue"}`,
        type: "danger",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid full-height">
      <h2 className="text-center text-primary fw-bold mb-3">
        AJOUTER UN COLIS
      </h2>

      {message.text && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
        >
          {message.text}
          <button
            type="button"
            className="btn-close"
            onClick={() => setMessage({ text: "", type: "" })}
          ></button>
        </div>
      )}

      <form className="p-4 shadow-lg rounded bg-light" onSubmit={handleSubmit}>
        <div className="row">
          {/* Code Client */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Code Client</label>
            <input
              type="text"
              className="form-control"
              name="client_code"
              value={formData.client_code}
              onChange={handleChange}
              required
            />
          </div>

          {/* Nom */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Nom</label>
            <input
              type="text"
              className="form-control"
              name="user_name"
              value={formData.user_name}
              onChange={handleChange}
              required
            />
          </div>

          {/* Numéro de colis */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Numéro de Colis</label>
            <input
              type="text"
              className="form-control"
              name="colis_number"
              value={formData.colis_number}
              onChange={handleChange}
              required
            />
          </div>

          {/* Poids */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Poids (kg)</label>
            <input
              type="text"
              className="form-control"
              name="weight"
              value={formData.weight}
              onChange={handleChange}
              required
            />
          </div>

          {/* Dimensions */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Dimensions</label>
            <input
              type="text"
              className="form-control"
              name="dimension"
              value={formData.dimension}
              onChange={handleChange}
              required
            />
          </div>

          {/* Prix */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Prix (Ar)</label>
            <input
              type="text"
              className="form-control"
              name="price"
              value={formData.price}
              onChange={handleChange}
              required
            />
          </div>

          {/* Mode d'envoi */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Mode d'Envoi</label>
            <select
              className="form-select"
              name="sending_option"
              value={formData.sending_option}
              onChange={handleChange}
              required
            >
              <option value="Aérien_Normal">Aérien_Normal</option>
              <option value="Aérien_Express">Aérien_Express</option>
              <option value="Envoi_Maritime">Envoi_Maritime</option>
            </select>
          </div>

          {/* Status */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Statut</label>
            <select
              className="form-select"
              name="status"
              value={formData.status}
              onChange={handleChange}
              required
            >
              <option value="Expédié">Expédié</option>
              <option value="Arrivé">Arrivé</option>
              <option value="Récupéré">Récupéré</option>
            </select>
          </div>

          {/* Date de départ */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Date de Départ</label>
            <input
              type="date"
              className="form-control"
              name="departure_date"
              value={formData.departure_date}
              onChange={handleChange}
              required
            />
          </div>

          {/* Date d'arrivée */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Date d'Arrivée</label>
            <input
              type="date"
              className="form-control"
              name="arrival_date"
              value={formData.arrival_date}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* Bouton Ajouter */}
        <div className="text-center">
          <button
            type="submit"
            className="btn btn-primary px-4"
            disabled={loading}
          >
            {loading ? "Chargement..." : "Valider +"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Add_colis;
